import React from 'react';
import { Card } from '@one-thd/sui-atomic-components';
import { CardProductLoader } from '../CardProductLoader/CardProductLoader';
import { CardSelectProductLoader } from '../CardSelectProductLoader/CardSelectProductLoader';
import { CardTitleLoader } from '../CardTitleLoader/CardTitleLoader';

export const CardCtaLoader = () => {
  return (
    <Card CardContentProps={{ grow: true }} data-component="PromotionProductsCardCtaLoader">
      <CardTitleLoader />
      <CardProductLoader />
      <CardSelectProductLoader />
    </Card>
  );
};

CardCtaLoader.displayName = 'CardCtaLoader';

CardCtaLoader.propTypes = {};

CardCtaLoader.defaultProps = {};
